module.exports = __webpack_public_path__ + "static/media/Background_Meine_Fächer.d94d7476.svg";